<template>
  <div
    v-if="tooltip?.visible"
    id="tooltip"
    class="interactive-tooltip shadow"
    :style="tooltip.style"
    :class="[
      tooltip.classes,
      `max-md:!min-w-auto max-md:!pointer-events-auto max-md:!fixed max-md:!bottom-0.5 max-md:!left-auto max-md:!right-1 max-md:!top-auto max-md:!z-40 max-md:!w-[calc(100%-2*var(--spacing))] max-md:!max-w-full max-md:!transform-none`,
      {
        'md:!w-full': tooltip.type !== 'custom',
        '!p-0 ': tooltip.type !== 'custom' || $windowSize.isMobile,
        'md:!max-w-55': tooltip.type !== 'custom' && type === 'Instance',
        'md:!max-w-75': tooltip.type !== 'custom' && type !== 'Instance',
      },
    ]"
  >
    <slot name="header"> </slot>

    <InstanceTooltip
      v-if="defaultData && type == 'Instance'"
      :instance="defaultData"
    ></InstanceTooltip>
    <StoreyTooltip
      v-else-if="defaultData && type == 'Storey'"
      :storey="defaultData"
    ></StoreyTooltip>
    <SectionTooltip
      v-else-if="defaultData && type == 'Section'"
      :section="defaultData"
    ></SectionTooltip>
    <EstateTooltip
      v-else-if="defaultData && type == 'Estate'"
      :estate="defaultData"
    ></EstateTooltip>
    <CatalogTooltip
      v-if="defaultData && type == 'InteractiveCatalogue'"
      :catalog="defaultData"
    ></CatalogTooltip>
    <!--
    <template v-if="tooltip.type == 'default'">
      <slot name="default-content"></slot>
    </template> -->
    <template v-else-if="tooltip.type == 'custom'">
      <slot name="custom-content">
        <div
          class="interactive-tooltip-custom-content vueberg-content max-h-[calc(var(--app-height)-12rem)] overflow-y-auto md:max-h-[calc(var(--app-height)/2)]"
          :class="{
            '!p-2': $windowSize.isMobile,
          }"
          v-html="tooltip.content"
        ></div>
      </slot>
    </template>
    <slot name="footer"> </slot>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import InstanceTooltip from '../tooltip/InstanceTooltip.vue';
import StoreyTooltip from '../tooltip/StoreyTooltip.vue';
import SectionTooltip from '../tooltip/SectionTooltip.vue';
import EstateTooltip from '../tooltip/EstateTooltip.vue';
import CatalogTooltip from '../tooltip/CatalogTooltip.vue';

export default {
  name: 'InteractiveTooltip',
  components: {
    InstanceTooltip,
    StoreyTooltip,
    SectionTooltip,
    EstateTooltip,
    CatalogTooltip,
  },
  props: {
    tooltip: {
      type: [Object, null],
      required: false,
      default: null,
    },
    type: {
      type: [String, null],
      required: false,
      default: null,

      validator(value) {
        return [
          'InteractiveCatalogue',
          'Instance',
          'Storey',
          'Section',
          'Estate',
          '',
          null,
        ].includes(value);
      },
    },
    id: {
      type: [String, Number, null],
      required: false,
      default: null,
    },
  },
  data() {
    return {};
  },

  computed: {
    ...mapGetters(['catalogs', 'instances', 'storeys', 'sections', 'estates']),

    defaultData() {
      if (this.tooltip.type !== 'default') {
        return null;
      }
      switch (this.type) {
        case 'Instance':
          return this.instances?.find((i) => i.id == this.id);
        case 'Storey':
          return this.storeys?.find((i) => i.id == this.id);
        case 'Section':
          return this.sections?.find((i) => i.id == this.id);
        case 'Estate':
          return this.estates?.find((i) => i.id == this.id);
        case 'InteractiveCatalogue':
          return this.catalogs?.items?.find((i) => i.id == this.id);
      }

      return null;
    },
  },
  watch: {},
  methods: {},
};
</script>

<style scoped></style>
